export default __webpack_public_path__ + "static/media/Riane_Eisler_2_AHV_In_Moms_We_Trust.ba35a474.jpg";